module.exports = __webpack_public_path__ + "static/media/wBTC-logo.acea5032.png";